import ManufacturerStore from "containers/Manufacturer/ManufacturerStore";
import ViewDetailsContainer from "./ViewDetailsContainer";

export default ManufacturerStore(ViewDetailsContainer);